import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import getLocation from "../services/location";
import { StoreList } from "../components/lists/StoreList";
import { useLocation } from "react-router-dom";
import PromoItemList from "../components/lists/PromoItemList";
import { Alert } from "@mui/material";

import { useDispatch } from "react-redux";
import { setError } from "../services/actions";
import { test_ip } from "../services/constants";

function Store(props) {
  const [lat, setLat] = useState(null);
  const [lon, setLon] = useState(null);
  const [single, setSingle] = useState(false);

  // const [items, setItems] = useState([]);
  const city_id = localStorage.getItem("city_id");

  // const [productList, setProductList] = useState([])
  const [storeList, setStoreList] = useState({
    stores: [],
    products: [],
    flag: false,
  });
  const [flag, setFlag] = useState(false);

  const nav = useNavigate();

  const diapach = useDispatch();

  const location = useLocation();
  const store = location.state.store;
  const delivery_id = location.state.delivery_id;
  const fetch = localStorage.getItem("fetched_stores");
  const store_product = localStorage.getItem("store_product");
  // console.log('fetch hign level', fetch)
  const roud_flag = location.state.round;
  // console.log(roud_flag, 'checking flag')
  if (roud_flag) {
    // console.log('rounding back')
    store.store_count = 1;
  }
  // console.log(productList)

  // if (single){
  //     nav(`/singleStor/${store._id}`, {state:{store:store,delivery_id:delivery_id}});
  // }
  useEffect(() => {
    getLocation((data) => {
      setLat(data.lat);
      setLon(data.lon);
    });
  }, []);
  useEffect(() => {
    var req_data = {
      city_id: city_id,
      company_id: store.company_id,
      store_delivery_id: delivery_id,
      longitude: lon,
      latitude: lat,
    };
    Get_Store_list_by_company(req_data);
    //  if (store.store_count > 1) {

    //     console.log(store.store_count,'hyy greater than 1')
    //     // setSingle(false)
    //     Get_Store_list_by_company(req_data)
    // }  else {
    //     // var data = { store_id: store._id}
    //     // Get_Product_list(data)
    //     console.log(store.store_count,'only 1')
    //     // setSingle(true)
    //     nav(`/singleStor/${store._id}`, {state:{store:store,delivery_id:delivery_id}});
    // }
  }, [lat, lon]);

  var Get_Store_list_by_company = function (data) {
    // per company if store_count > 1
    var body = {
      company_id: data.company_id,
      store_delivery_id: data.store_delivery_id,
      city_id: data.city_id,
      latitude: data.latitude,
      longitude: data.longitude,
    }; // campany id can be found on store data
    body = JSON.stringify(body);
    axios
      .post(`${test_ip}api/user/get_store_list_by_company`, body, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          console.log(res.data);
          if (res.data.success == true) {
            var stores = res.data.stores;

            // localStorage.setItem('fetched_stores','true')
            setStoreList({ stores: stores, products: [], flag: true });
            // setFlag(true) // all store companies in a single delivery type
          } else {
            console.log(res.data.error_code);
            diapach(
              setError({
                error: true,
                message: "failed to fetch branches,please reload",
              })
            );
          }
        } else {
          // do something
          diapach(
            setError({
              error: true,
              message: "failed to fetch branches,please reload",
            })
          );
        }
      })
      .catch((err) => {
        // do something
        diapach(
          setError({
            error: true,
            message: "failed to fetch branches,please reload",
          })
        );
      });
  };
  return (
    <div className="delivery_container">
      {/* <StoreList list={stores}/> */}
      <div
        style={{
          backgroundColor: "white",
          marginTop: "5px",
          marginBottom: "5px",
          padding: "8px",
          fontSize: "0.8rem",
        }}
      >
        <h3 style={{ fontSize: "1.2rem" }}>
          {storeList.stores.length} Branches
        </h3>
        <div style={{ fontSize: "0.6rem" }}>
          choose which branch you want to order from ....
        </div>
      </div>
      <StoreList
        list={storeList.stores}
        delivery_id={delivery_id}
        flag={true}
      />
      {/* <PromoItemList promo={storeList.products}/> */}
      {/* <PromoItemList promo={productList}/> */}
    </div>
  );
}

export default Store;
